<div mat-dialog-content class="scroller">
  <div class="quote-header">
    <h3>Get a Quote</h3>
    <p>Share your Requirements with us.</p>
    <button mat-icon-button color="primary" class="subcSend" type="button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="quote-form">
    <form [formGroup]="quoteForm" (ngSubmit)="quoteSubmit()">
        <div class="row">
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Name <sup>*</sup></label>
                    <mat-form-field  appearance="outline">
                        <input matInput formControlName="name" placeholder="Enter your full name" >
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('name')?.hasError('required') && quoteForm?.get('name')?.touched">
                            Username is required
                        </div>
                        <div
                            *ngIf="quoteForm?.get('name')?.hasError('minlength') && quoteForm?.get('name')?.touched">
                            Username must be at least 4 characters long
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Company Email <sup>*</sup></label>
                    <mat-form-field  appearance="outline">
                        <input matInput formControlName="companyEmail" placeholder="Enter your company email" >
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('companyEmail')?.hasError('required') && quoteForm?.get('companyEmail')?.touched">
                            Email is required
                        </div>
                        <div *ngIf="quoteForm?.get('companyEmail')?.value">
                            <div
                                *ngIf="!validateEmail && quoteForm?.get('companyEmail')?.touched">
                                Must be a valid email address
                            </div>
                        </div>
                    </div>
                    <!-- <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('companyEmail')?.hasError('required') && quoteForm?.get('companyEmail')?.touched">
                            Company email is required
                        </div>
                        <div
                            *ngIf="quoteForm?.get('companyEmail')?.hasError('pattern') && quoteForm?.get('companyEmail')?.touched">
                            Must be a valid email address
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label>Mobile No. <sup>*</sup></label>
                    <div class="mobileItem d-flex">
                        <mat-form-field class="countryCode" appearance="outline">
                            <mat-select formControlName="countryCode">
                                <mat-option value="+91">+91</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="mobileNo" appearance="outline">
                            <input matInput formControlName="mobile" placeholder="Enter mobile number">
                        </mat-form-field>
                    </div>
                    <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('mobile')?.hasError('required') && quoteForm?.get('mobile')?.touched">
                            Mobile number is required
                        </div>
                        <div
                            *ngIf="quoteForm?.get('mobile')?.hasError('pattern') && quoteForm?.get('mobile')?.touched">
                            Must be a valid mobile number
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Company <sup>*</sup></label>
                    <mat-form-field  appearance="outline">
                        <input matInput formControlName="company" placeholder="Enter your company name" >
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('company')?.hasError('required') && quoteForm?.get('company')?.touched">
                            Company is required
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Country <sup>*</sup></label>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="country" placeholder="Select Country">
                            <mat-option value="">Select Country</mat-option>
                            <mat-option *ngFor="let data of countryData" [value]="[data.id, data.countryName]">{{data.countryName}} </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('country')?.hasError('required') && quoteForm?.get('country')?.touched">
                            Country is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Industry <sup></sup></label>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="industry" placeholder="Select Industry">
                            <mat-option value="">Select Industry</mat-option>
                            <mat-option *ngFor="let data of industryData"
                                                    [value]="[data.id, data.industryName]">{{data.industryName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Category <sup>*</sup></label>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="category" placeholder="Select Category">
                            <mat-option [value]="">Select Category</mat-option>
                            <mat-option *ngFor="let data of categoryData"
                                                    [value]="[data.id, data.categoryName]">{{data.categoryName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="quoteForm?.get('category')?.hasError('required') && quoteForm?.get('category')?.touched">
                            Category is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="formGroup">
                    <label for="">Type of Enquiry <sup></sup></label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Select">
                            <mat-option [value]="">Select</mat-option>
                            <mat-option *ngFor="let data of enquiryData"
                            [value]="[data.id, data.enquiryName]">{{ data.enquiryName }}</mat-option>
                            <!-- <mat-option value="1">Manufacuring</mat-option>
                            <mat-option value="2">Account Related</mat-option>
                            <mat-option value="3">Become a supplier</mat-option>
                            <mat-option value="4">Others</mat-option> -->
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-12 col-12">
                <div class="formGroup">
                    <label for="">Comments</label>
                    <mat-form-field appearance="outline">
                        <textarea matInput  placeholder="Drop a note, or tell us about your project..."></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="submitBtn">
                <button mat-button type="submit" class="btn-custom btn-solid" [ngClass]="{'disable': isValid()}">Submit</button>
            </div>
        </div>
    </form>
  </div>
</div>
<!-- <div mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
</div> -->